<div class="wrapper">
    <div class="loader" [ngClass]="getLoaderType()">
        <div class="large-mocks" *ngIf="type === 'large'">
            <div class="spaces"></div>
            <div class="spaces"></div>
            <div class="spaces"></div>
            <div class="spaces"></div>
        </div>

        <div class="inline-mocks" *ngIf="type === 'inline'">
            <div class="spaces"></div>
            <div class="spaces"></div>
            <div class="spaces"></div>
            <div class="spaces"></div>
        </div>

        <div class="grid-tall-mocks" *ngIf="type === 'grid-tall'">
            <div class="spaces"></div>
            <div class="spaces"></div>
        </div>

        <div class="grid-tall-mocks" *ngIf="type === 'card'">
            <div class="spaces"></div>
        </div>
    </div>
</div>
